import React from 'react';
import { Section, SectionSubTitle } from 'common/components';
import { css } from 'linaria';

const kitchenVideoSection = css`
  && {
    @media (--only-desktop) {
      margin-bottom: 80px;
    }
  }
`;

const kitchenVideoItem = css`
  width: 100%;
  height: auto;
  border-radius: var(--rounding-m);
`;

export const KitchenVideo: React.FC = () => (
  <Section className={kitchenVideoSection}>
    <SectionSubTitle margin="m">Делаем кухни по&nbsp;европейским стандартам</SectionSubTitle>
    <video
      className={kitchenVideoItem}
      title="Делаем кухни по европейским стандартам"
      controls
      autoPlay
      muted>
      <source
        src="https://cdn.lemanapro.ru/lmru/image/upload/video/fudzi/mf-landings-web%252Fvideo%252FDelinia_ID.mp4/Delinia_ID.mp4"
        type="video/mp4"
      />
    </video>
  </Section>
);
